<template>
  <div class="download-top-container" @click="toDownload" v-track="{ name: 'toDownload' }"></div>
</template>

<script>
export default {
  // 每页顶部的下载展示
  name: 'DownloadTop',
  methods: {
    toDownload() {
      this.$router.push('/download')
    }
  }
}
</script>

<style lang="scss" scoped>
  .download-top-container {
  	position: fixed;
  	top: 0;
  	left: 0;
  	right: 0;
    z-index: 999;
  	height: 48px;
  }

  /* 为了在百度浏览器下不被屏蔽 */
  .download-top-container::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 48px;
    background-size: 100% 100%;
    background-image: url('../../assets/download-top/download.png');
  }
</style>
